
import { Vue, Component, Prop } from 'vue-property-decorator'
import InfoBanner from '@/components/processing_steps/banners/InfoBanner.vue'
import axios from 'axios'
import { API_URLS } from "@/utils/helpers"

@Component({
  components: {
    InfoBanner
  }
})
export default class OrgaHasNoTemplateBanner extends Vue {
  @Prop({ default: false }) isSiteAdmin!: boolean
  availableTemplates: { value: string, text: string }[] = []
  show = false

  async mounted (): Promise<void> {
    await this.fetchAvailableTemplates()
    this.setShowInfoBanner()
  }

  async fetchAvailableTemplates () {
    await axios.get(API_URLS.SHOWCASE_PAGE_TEMPLATE.AVAILABLE_TEMPLATES).then((response) => {
      this.availableTemplates = response.data
    })
  }

  setShowInfoBanner (): void {
    if (this.isSiteAdmin) return
    this.show = this.availableTemplates.length === 0
    if (this.show) {
      this.$emit('open-info-modal')
    }
  }

  closeInfoModal () {
    this.show = false
    this.$emit('close-info-modal')
  }
}

